import { render, staticRenderFns } from "./cModalQuotes.vue?vue&type=template&id=bd4daa18&scoped=true"
import script from "./cModalQuotes.vue?vue&type=script&lang=js"
export * from "./cModalQuotes.vue?vue&type=script&lang=js"
import style0 from "./cModalQuotes.vue?vue&type=style&index=0&id=bd4daa18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4daa18",
  null
  
)

export default component.exports